import {
  classesSpotIcon,
  onlineClassesSpotIcon
} from "@lululemon/dsp-ecom-pattern-library";

export default {
  components: {
    breadcrumbs: {
      storesLabel: "Stores"
    },
    storeDetails: {
      disclaimer: "Due to safety precautions, there might be a lineup to shop.",
      staticMapButtonText: "Get Directions",
      amenitiesSubheader: "Store Services & Amenities",
      blockLinks: {
        appointments: {
          id: "appointments",
          headline: "Book",
          heading: "Appointments",
          subContent: "Book a time to shop in-store.",
          ctaLabel: "Reserve"
        },
        classes: {
          id: "classes",
          headline: "Sweat",
          heading: "Classes",
          subContent:
            "Discover weekly classes led by our favourite local teachers and trainers.",
          ctaLabel: "Book"
        },
        events: {
          id: "events",
          headline: "Grow",
          heading: "Events",
          subContent:
            "Listen, learn, watch, have a voice. Join our in-store events.",
          ctaLabel: "Explore"
        },
        directions: {
          id: "directions",
          headline: "Visit",
          heading: "Find us",
          subContent: "How to get here. We put fun on the map.",
          fullAddress: "",
          get ctaUrl() {
            return `${this.fullAddress}`;
          }
        },
        mirror: {
          id: "mirror",
          headline: "Discover",
          heading: "Mirror",
          subContent: "Experience the nearly invisible home gym yourself.",
          ctaLabel: "Discover",
          ctaUrl: "#"
        },
        food: {
          id: "food",
          headline: "Food & Drinks",
          heading: "Food & Drinks",
          subContent:
            "Feeling hungry? Definitely thirsty? View our full menu and order online.",
          ctaLabel: "Order"
        },
        footwear: {
          id: "footwear",
          headline: "Try On",
          heading: "Our Shoes",
          subContent:
            "Make an in-store appointment to experience lululemon for your feet."
        }
      },
      fuelMenuCtaLabel: "Details",
      fuelMenuSubContent:
        "Feeling hungry? Definitely thirsty? You'll find it in our Fuel Space.",
      footwearSubContent: "Book a time to shop in store or try on our shoes.",
      spaceHours: {
        storeHours: "Store Hours",
        studioHours: "Studio Hours",
        cafeHours: "Cafe Hours",
        openToday: "Open today",
        specialHours: "Special hours",
        today: "today",
        closed: "closed"
      }
    },
    sweatWithUs: {
      regular: {
        heading: "Sweat with us",
        description:
          "From yoga classes and mindful moments, to high-intensity training sessions, to runs of all distances, we believe sweat has the power to bring people together.",
        cta: {
          heading: "Discover online classes.",
          subContent: "Practice with us anytime, anywhere.",
          href: "https://shop.lululemon.com/story/community-carries-on"
        },
        featureBlocks: [
          {
            title: "Practice Yoga",
            blurb:
              "All-levels classes led by inspiring teachers. Relax, unwind, and clear your mind or build strength and get present. <a href='https://shop.lululemon.com/story/yoga-videos' target='_blank'>Find the right class for you.</a>",
            iconContent: classesSpotIcon,
            isEmbeddedBlurb: true
          },
          {
            title: "Run Training Guides",
            blurb:
              "From your first jog to your fiftieth race, we've got tools to kick your training up a notch. <a href='https://shop.lululemon.com/stories/marathon-training-plans-pdf' target='_blank'>Explore our run training guides.</a>",
            iconContent: onlineClassesSpotIcon,
            isEmbeddedBlurb: true
          }
        ]
      },
      experiential: {
        heading: "Sweat with us",
        description:
          "From increasing your heart rate to getting over a heartbreak, we have classes and events that support every reason to get sweaty. Pop into our store to find out more.",
        cta: {
          heading: "See our in-store schedule.",
          subContent: "Sign up now with MINDBODY.",
          href: ""
        },
        featureBlocks: [
          {
            title: "Classes",
            blurb:
              "Connect with our favourite local teachers and trainers over a good sweat on the mat, bike, roads, and trails. Don’t forget your water bottle.",
            iconContent: classesSpotIcon,
            isEmbeddedBlurb: false
          },
          {
            title: "Events",
            isEmbeddedBlurb: true,
            embeddedHref: "", // updated based on storeData
            get blurb() {
              return `From workshops to sweat sessions with local ambassadors, our community events start conversations and inspire action. Listen, learn, watch, and have a voice. <a href='${this.embeddedHref}' target='_blank'>Discover all of our local events.</a>`;
            },
            iconContent: onlineClassesSpotIcon
          }
        ]
      },
      experientialTemplate: {
        studioClasses: {
          id: "studioClasses",
          title: "Studio Classes",
          blurb:
            "Tap into the incredible energy and mindfulness of our studio classes. Just grab your mat and get ready for grounding yoga, energizing HIIT and boot camp classes, and more.",
          ctaHeading: "View class schedule",
          ctaSubContent: "Your feel-good endorphins are waiting."
        },
        communityEvents: {
          id: "communityEvents",
          title: "Community Events",
          blurb: `Motivation, movement, and change are a click away. Join inspiring local leaders, teachers, and entrepreneurs for workshops and events designed to spark action in your community.`,
          ctaHeading: "Browse upcoming events",
          ctaSubContent: "Something to get you fired up."
        },
        eventsAndRentals: {
          id: "eventsAndRentals",
          title: "Private Events & Rentals",
          blurb: `Make good times happen. Bring your crew together for personal shopping, sweat classes, meditation, workshops, and even dinner and drinks. Get in touch to customize your experience.`,
          ctaHeading: "Email us to get started",
          ctaSubContent: "Design an event they’ll never forget."
        }
      }
    },
    promoBanner: {
      heading: "Shopping made easier? Yes, please.",
      blurb:
        "Now it's faster and easier to get the gear you want with our in-store and online shopping services.",
      button: {
        text: "Learn More",
        href: "https://shop.lululemon.com/story/services"
      },
      backgroundImage:
        "https://images.lululemon.com/is/image/lululemon/RTO_Service_Page_1_1_Masonry_D"
    },
    socialBanner: {
      heading: "Be the first to know",
      subContent:
        "Get all the need-to-know information about new products, stories, and events in our weekly email.",
      button: {
        text: "Subscribe",
        href: "https://shop.lululemon.com/secure/account/email-landing.jsp"
      },
      image: {
        src: "https://images.lululemon.com/is/image/lululemon/ExpStore_LincolnPark_Homepage_EmailSignup_ImageBottom@2x",
        alt: "Follow Us",
        maxWidth: 582
      },
      socialLinksDefault: {
        twitter: {
          url: "https://twitter.com/lululemon",
          label: "@lululemon"
        },
        facebook: {
          url: "https://www.facebook.com/lululemon",
          label: "lululemon"
        },
        instagram: {
          url: "https://www.instagram.com/lululemon/",
          label: "@lululemon"
        },
        chat: {
          url: "https://shop.lululemon.com/live-chat",
          label: "Live chat with us"
        }
      }
    },
    storeSpace: {
      ctaBlocks: {
        classes: "See all classes at this store",
        events: "See all events at this store",
        directions: "Get directions"
      },
      ctaGrid: {
        heading: "About the space",
        modalHeading: "Space Amenities",
        openModalText: "See all amenities"
      },
      tuneBedBookingHeading: "Book a Tune session"
    },

    storeLocator: {
      map: {
        markerIconUrl:
          "https://images.lululemon.com/is/image/lululemon/Location_pin?$pngstandard$"
      },
      list: {
        showAllStoresLabel: "See all store listings"
      },
      storeInfoCard: {
        typeLabelExperiential: "Experiential",
        typeLabelOther: "Store",
        distanceLabelSuffix: "away",
        storeLinkLabel: "Store details",
        selectThisStore: "Select this store"
      },
      heading: "Find a Store",
      tabList: {
        map: "Map",
        list: "List"
      }
    },
    spacesGrid: {
      regular: {
        heading: "Spaces in-store",
        description:
          "From fitness to wellness to food, this store is designed to serve all the ways we sweat, grow, and connect.",
        modal: {
          heading: "Store Amenities",
          open: "See all amenities",
          maxListItems: 3,
          experientialStoreOpen: "More amenities"
        }
      },
      experientialTemplate: {
        heading: "Our Spaces",
        description:
          "Grab your favourite gear and put it to work—every space in our experiential store is designed for you to sweat, grow, and connect."
      }
    },
    storeList: {
      pageHeading: "All store locations",
      countrySelectLabelEn: "Country",
      countrySelectLabelFr: "Pays",
      countrySelectOptionsEn: [
        {
          value: "CA",
          label: "Canada"
        },
        {
          value: "US",
          label: "United States"
        }
      ],
      countrySelectOptionsFa: [
        {
          value: "CA",
          label: "Canada"
        },
        {
          value: "US",
          label: "États-Unis"
        }
      ]
    }
  }
};
